<script>
    import { onMount } from 'svelte'
    import { apiURL } from '../../store.js'
    import { getHash } from '../../js/hash-scroll.js'
    import Vimeo from './Vimeo.svelte'
    import Expandable from './Expandable.svelte'

    export let section
    export let color
    export let sub = false
</script>

<div class="section" style="--pageColor: {color};">
    <h2 class="sectionTitle" class:sub id={getHash(section.title)}>
        {section.title}
    </h2>
    {#each section.content as contentBlock}
        {#if contentBlock.type == 'header'}
            <h2>{@html contentBlock.value}</h2>

        {:else if contentBlock.type == 'vimeo_link'}
            <div class="vimeoBox">
                <Vimeo src={contentBlock.value} />
            </div>

        {:else if contentBlock.type == 'paragraph'}
            {@html contentBlock.value}

        {:else if contentBlock.type == 'image'}
            <img src="{apiURL}{contentBlock.value.url}" alt={contentBlock.value.title} />

        {:else if contentBlock.type == 'halfsize_image_left'}
            <img class="half left" src="{apiURL}{contentBlock.value.url}" alt={contentBlock.value.title} />

        {:else if contentBlock.type == 'halfsize_image_right'}
            <img class="half right" src="{apiURL}{contentBlock.value.url}" alt={contentBlock.value.title} />

        {:else if contentBlock.type == 'halfsize_Image_With_Caption_Right'}
            <div class="halfImgContainer right">
                <img src="{apiURL}{contentBlock.value.image.url}" alt="captioned" />
                <div class="halfCaption">
                    {@html contentBlock.value.caption}
                </div>
            </div>

        {:else if contentBlock.type == 'halfsize_Image_With_Caption_Left'}
            <div class="halfImgContainer left">
                <img src="{apiURL}{contentBlock.value.image.url}" alt="captioned" />
                <div class="halfCaption">
                    {@html contentBlock.value.caption}
                </div>
            </div>

        {:else if contentBlock.type == 'section_link'}
            <a href={contentBlock.value.url} class="sectionLink">
                {contentBlock.value.display_text}
            </a>

        {:else if contentBlock.type == 'captioned_image'}
            <img class="captioned" src="{apiURL}{contentBlock.value.image.url}" alt="captioned" />
            <div class="caption">
                {contentBlock.value.caption}
            </div>

        {:else if contentBlock.type == 'expandable_vimeo'}
            <Expandable {color}>
                <span slot="label" class="expandableLabel">
                    {contentBlock.value.visible_text}
                </span>
                <div slot="hidden" class="expandedVideo">
                    <Vimeo src={contentBlock.value.vimeo_link} />
                </div>
            </Expandable>

        {:else if contentBlock.type == 'expandable_section'}
            <Expandable {color}>
                <span slot="label" class="expandableLabel">
                    {contentBlock.value.visible_text}
                </span>
                <div slot="hidden" class="expandedText">
                    {@html contentBlock.value.hidden_text}
                </div>
            </Expandable>
        {:else if contentBlock.type === 'divider_line'}
            <div class="dividerLine" />
        {/if}
    {/each}
</div>

<style lang="scss">
    @import "../../styles/vars";

    .dividerLine {
        width: 100%;
        height: 1px;
        background-color: black;
    }

    .section:first-of-type .sectionTitle {
        margin-top: 0;
    }

    @include respond-to(computer) {
        .halfImgContainer {
            width: 45%;
            img {
                width: 100%;
            }
            &.left {
                float: left;
                margin: 1rem 2rem 1rem 0;
            }
            &.right {
                float: right;
                margin: 1rem 0 2rem 1rem;
            }
        }
        :global(.halfCaption p) {
            font-family: "Work Sans" !important;
            font-size: 0.8rem !important;
        }
        .vimeoBox {
            width: 90%;
            margin: 2rem 5%;
            clear: both;
        }
        .section {
            margin-top: 5rem;
            &:first-child {
                margin-top: 0;
            }
            &::after {
                content: "";
                clear: both;
                display: table;
            }
        }
        .caption {
            box-sizing: border-box;
            width: 100%;
            padding: 0.2rem 8% 1rem;
            font-family: "Work Sans", Helvetica, sans-serif;
            font-size: 0.9rem;
            margin-bottom: 2rem;
            font-feature-settings: 'ss01', 'ss06';
        }
        .section :global(p) {
            font-family: "Ysabeau";
            font-size: 1.2rem;
        }

        .section :global(a) {
            color: black;
            border-bottom: 2px solid var(--pageColor);
            font-family: "Ysabeau"
        }
        .section :global(a:hover) {
            text-decoration: none;
        }

        img {
            width: 90%;
            height: auto;
            &.captioned {
                margin-bottom: 0;
            }
            &.half {
                width: 45%;
                &.left {
                    float:left;
                    margin: 1rem 2rem 1rem 0rem;
                }
                &.right {
                    float:right;
                    margin: 1rem 0 1rem 2rem;
                }
            }
        }
        .sectionLink {
            margin-bottom: 1rem;
        }
    }

    @include respond-to(phone) {
        .section {
            margin-top: 3rem;
            &:first-child {
                margin-top: 0;
            }
        }
        .caption {
            box-sizing: border-box;
            width: 100%;
            padding: 0.2rem 2% 1rem;
            font-family: "Work Sans", Helvetica, sans-serif;
            font-size: 0.8rem;
            line-height: 1rem;
            margin-bottom: 0.6rem;
            font-feature-settings: 'ss01', 'ss06';
        }
        .section :global(p) {
            font-family: "Ysabeau";
            font-size: 1.08rem;
            line-height: 1.45rem;
            margin: 0.6rem 0 1rem 0;
        }
        .section :global(a) {
            color: black;
            border-bottom: 2px solid var(--pageColor);
            font-family: "Ysabeau"
        }
        .section :global(a:hover) {
            text-decoration: none;
        }

        img {
            width: 96%;
            margin: 1rem 2%;
            height: auto;
            &.captioned {
                margin-bottom: 0;
            }
        }
        .sectionLink {
            margin-bottom: 1rem;
        }
    }

    :global(.expandedText p) {
        margin: 0;
    }

    .expandedVideo {
        padding: 2rem 10px;
    }

    .expandableLabel {
        font-family: "Ysabeau";
        font-weight: 600;
        font-size: 1.25rem;
        margin-bottom: 0;
        display: inline-block;
        pointer-events: none;
        border-bottom: 2px solid var(--pageColor);
    }
</style>
